export enum KeyCodes {
  Tab = 9,
  Enter = 13,
  Shift = 16,
  Escape = 27,
  Space = 32,
  Up = 38,
  Down = 40,
  Zero = 48,
  One = 49,
  Two = 50,
  Three = 51,
  Four = 52,
  Five = 53,
  Six = 54,
  Seven = 55,
  Eight = 56,
  Nine = 57,
  Backspace = 8,
  Delete = 46,
  Left = 37,
  Right = 39,
}
